var _path, _path2, _g, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBlockFodder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43_713)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 45C66.5 61.0163 53.5163 74 37.5 74C21.4837 74 8.5 61.0163 8.5 45C8.5 28.9837 21.4837 16 37.5 16C53.5163 16 66.5 28.9837 66.5 45Z",
    stroke: "#364052",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_43_713",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 15,
    width: 61,
    height: 60
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 75C54.0685 75 67.5 61.5685 67.5 45C67.5 28.4315 54.0685 15 37.5 15C20.9315 15 7.5 28.4315 7.5 45C7.5 61.5685 20.9315 75 37.5 75Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_43_713)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.01953 54.418H69.7275V75.268H8.07853L8.01953 54.418Z",
    fill: "#364052"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.34 12.002C57.41 17.207 52.487 22.412 49.339 28.013C46.829 22.743 43.818 18.008 38.698 15.547C43.004 20.539 44.885 25.534 46.138 30.526C43.671 29.446 40.908 28.657 37.781 28.272C41.458 29.662 44.366 31.333 46.741 33.205C46.391 34.059 46.028 34.905 45.668 35.752C44.867 35.408 44.04 35.073 43.105 34.672C43.918 35.32 44.632 36.002 45.267 36.716C44.713 38.103 44.225 39.536 43.965 41.12C40.923 37.048 37.962 32.4 34.188 33.6C40.973 39.44 40.964 49.254 40.1 55.229C38.279 51.019 37.459 43.536 34.188 39.508C35.838 44.068 34.942 51.774 34.764 56.333H46.907C47.884 53.52 48.691 47.583 49.427 44.803C50.175 47.595 50.503 53.595 50.872 56.333H65.385C65.031 50.237 64.061 39.395 69.754 31.881C65.748 34.031 62.853 38.061 61.479 44.669C61.079 44.052 60.656 43.429 60.218 42.806C62.474 32.782 64.888 23.114 75.45 32.416C65.68 19.258 60.603 27.943 55.658 37.238C54.5821 36.1299 53.4307 35.0978 52.212 34.149C54.234 26.954 56.9 19.67 62.34 12V12.002ZM15.166 31.988C17.907 38.219 18.314 44.454 19.356 50.685C16.226 46.495 13.276 42.062 7 42.197C11.901 44.992 13.203 52.259 14.62 56.334H34.52C33.778 52.888 33.559 46.209 31.715 42.949C31.694 45.634 31.69 47.878 29.997 51.008C29.835 49.888 30.201 48.736 30.857 47.568C29.14 47.913 28.245 49.246 27.527 50.792C28.958 44.87 28.573 39.058 33.115 32.952C28.051 36.545 26.398 41.556 23.547 46.066C21.241 41.196 19.569 36.094 15.166 31.988ZM51.251 37.715C52.0991 38.7831 52.879 39.9037 53.586 41.07C53.316 41.559 53.048 42.05 52.776 42.52C52.14 41.211 51.498 40.188 50.826 39.355C50.966 38.808 51.11 38.26 51.251 37.712V37.715ZM49.07 48.63C49.13 50.15 48.29 54.817 47.317 56.335H50.653C50.183 54.758 49.664 50.082 49.07 48.63Z",
    fill: "#364052"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_713"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBlockFodder);
export default __webpack_public_path__ + "static/media/ic-block-fodder.3430c106c3a05389c163ec8a68782adb.svg";
export { ForwardRef as ReactComponent };